export const depositBeneficiaryReferences = {
  reos: 'Transfer to managed deposit account on reOS',
  depositAccountBankName: "Payment to agency's",
  depositAccountNumber: 'account *****',
  ownerBankName: "Payment to owner's",
  ownerAccountNumber: 'account *****',
}
